import { lazy, type ComponentType } from 'react'

/**
 * Router minimal SPA (T121).
 *
 * Tidak ada library router — dashboard ini cukup sederhana. Rute besar
 * memakai `lazy()` supaya muat pertama ringan. Rute terlindungi mengarahkan
 * ke login tanpa merender isi.
 */

export interface RouteDefinition {
  path: string
  component: ComponentType
  /** 'seller' | 'admin' | 'any' */
  role: 'seller' | 'admin' | 'any'
}

// Lazy-loaded route components
const LoginPage = lazy(() => import('../routes/LoginPage'))
const SellerDashboard = lazy(() => import('../routes/SellerDashboard'))
const AdminDashboard = lazy(() => import('../routes/AdminDashboard'))
const AdminPayments = lazy(() => import('../routes/admin/PaymentsPage'))
const AdminRefunds = lazy(() => import('../routes/admin/RefundsPage'))
const AdminConfig = lazy(() => import('../routes/admin/ConfigPage'))
const AdminAudit = lazy(() => import('../routes/admin/AuditPage'))
const AdminStats = lazy(() => import('../routes/admin/StatsPage'))
const SellerOnboarding = lazy(() => import('../routes/seller/OnboardingPage'))
const SellerProducts = lazy(() => import('../routes/seller/ProductsPage'))
const SellerOrders = lazy(() => import('../routes/seller/OrdersPage'))
const SellerFinance = lazy(() => import('../routes/seller/FinancePage'))
const SellerPayout = lazy(() => import('../routes/seller/PayoutPage'))
const SellerInviteTasks = lazy(() => import('../routes/seller/InviteTasksPage'))
const SellerChat = lazy(() => import('../routes/seller/ChatPage'))
const NotFoundPage = lazy(() => import('../routes/NotFoundPage'))

export const ROUTES: RouteDefinition[] = [
  { path: '/login', component: LoginPage, role: 'any' },
  { path: '/seller/onboarding', component: SellerOnboarding, role: 'seller' },
  { path: '/seller/products', component: SellerProducts, role: 'seller' },
  { path: '/seller/orders', component: SellerOrders, role: 'seller' },
  { path: '/seller/finance', component: SellerFinance, role: 'seller' },
  { path: '/seller/payout', component: SellerPayout, role: 'seller' },
  { path: '/seller/invite-tasks', component: SellerInviteTasks, role: 'seller' },
  { path: '/seller/chat', component: SellerChat, role: 'seller' },
  { path: '/seller', component: SellerDashboard, role: 'seller' },
  { path: '/admin/payments', component: AdminPayments, role: 'admin' },
  { path: '/admin/refunds', component: AdminRefunds, role: 'admin' },
  { path: '/admin/config', component: AdminConfig, role: 'admin' },
  { path: '/admin/audit', component: AdminAudit, role: 'admin' },
  { path: '/admin/stats', component: AdminStats, role: 'admin' },
  { path: '/admin', component: AdminDashboard, role: 'admin' },
]

export function matchRoute(pathname: string): RouteDefinition | null {
  return ROUTES.find((r) => pathname === r.path || pathname.startsWith(`${r.path}/`)) ?? null
}

export { NotFoundPage }
